import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appResize]'
})
export class ResizeDirective {

  @Output() resizeChange = new EventEmitter<any>();

  constructor(
    private el: ElementRef,
  ) { }

  @HostListener('resize', ['$event']) public onScroll(event): void {
    const params = {
      element: this.el,
      event
    };
    this.resizeChange.next(params);
  }
}
